import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Prodotti from '../views/Prodotti.vue'
import Linee from '../views/Linee.vue'
import Help from '../views/Help.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'Home', component: Home },
  { path: '/welcome/:token', name: 'Home', component: Home },
  { path: '/prodotti', name: 'Prodotti', component: Prodotti },
  { path: '/linee', name: 'Linee', component: Linee },
  { path: '/help', name: 'Help', component: Help },
]

const router = new VueRouter({
  routes
})

export default router
